import {Placemark} from "@iminside/react-yandex-maps";
import {YandexPlacemarkProps} from "../model/types";

export const YandexPlacemark = ({onActionsReady, ...props}: YandexPlacemarkProps) => {
    return (
        <Placemark
            {...props}
            instanceRef={(instance) => {
                if (!instance) {
                    onActionsReady?.(null);
                    return;
                }

                onActionsReady?.({
                    openBalloon: () => instance.balloon.open(),
                    closeBalloon: () => instance.balloon.close(),
                });
            }}
        />
    );
};
